/**
 * @file: MentionedText.tsx
 *
 * Renders a plain-text chat bubble body with `@mention` runs highlighted.
 * Ranges come from the message payload's `mentions[]`; everything else
 * renders as normal text. Mention spans are nested RN `Text` so they wrap
 * inline with the surrounding text (no layout break).
 */

import { Typography } from '@euler/app/components/typography';
import { splitTextByMentions } from '@euler/app/flows/chat/utils/mentions';
import { FontFamily } from '@euler/components/typography';
import { ChatMessageMention } from '@euler/model/chat';
import { FC } from 'react';
import { Text } from 'react-native';

export const MentionedText: FC<{
  text: string;
  mentions?: ChatMessageMention[];
  size: number;
  lineHeight: number;
  isMine: boolean;
}> = ({ text, mentions, size, lineHeight, isMine }) => {
  const segments = splitTextByMentions(text, mentions);
  const baseColor = isMine ? '#fff' : '#111';
  // Accent tint that stays legible on each bubble background (blue bubble
  // for own messages, light grey for received).
  const mentionColor = isMine ? '#cfe2ff' : '#2563EB';
  return (
    <Typography.Text
      size={size}
      lineHeight={lineHeight}
      color={baseColor}
      style={{ fontFamily: FontFamily.NotoSans.Regular }}
    >
      {segments.map((seg, i) =>
        seg.mention ? (
          <Text
            key={i}
            style={{
              color: mentionColor,
              fontFamily: FontFamily.NotoSans.Medium,
            }}
          >
            {seg.text}
          </Text>
        ) : (
          seg.text
        ),
      )}
    </Typography.Text>
  );
};
